/* Lisa & Salman: upsell in winkelwagen + sticky add to cart (Dawn). Claude 15-10-2026 */
(function(){
  document.addEventListener('click', function(e){
    var nav = e.target.closest && e.target.closest('[data-up-nav]');
    if (nav) { var r = nav.parentNode.querySelector('.cl-up__row'); r.scrollBy({ left: r.clientWidth * Number(nav.dataset.upNav), behavior: 'smooth' }); return; }
    var b = e.target.closest && e.target.closest('[data-up-add]');
    if (!b) return;
    e.preventDefault();
    var item = b.closest('.cl-up__item'), sel = item.querySelector('.cl-up__var');
    b.disabled = true; b.textContent = '…';
    var cd = document.querySelector('cart-drawer');
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(sel.value), quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function(r){ return r.json(); }).then(function(j){
      if (j.status) { b.textContent = 'Sold out'; return; }
      if (cd && cd.renderContents) cd.renderContents(j); else location.reload();
    }).catch(function(){ b.disabled = false; b.textContent = 'Add'; });
  });

  function sticky(){
    var bar = document.getElementById('ClSticky'); if (!bar) return;
    var data; try { data = JSON.parse(document.getElementById('ClStickyData').textContent); } catch (e) { return; }
    var selects = bar.querySelectorAll('select[data-index]'), price = bar.querySelector('[data-price]'), was = bar.querySelector('[data-was]'), btn = bar.querySelector('[data-add]'), img = bar.querySelector('[data-img]');
    var form = document.querySelector('product-form form[action*="/cart/add"]'), mainBtn = form && form.querySelector('[name="add"]');
    function cur(){ var o = Array.prototype.map.call(selects, function(s){ return s.value; }); return data.find(function(v){ return v.options.every(function(x, i){ return o[i] === undefined || x === o[i]; }); }); }
    function upd(){ var v = cur(); if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      price.textContent = v.price; was.textContent = v.compare || ''; was.hidden = !v.compare; if (v.image && img) img.src = v.image;
      btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Sold out'; }
    selects.forEach(function(s){ s.addEventListener('change', upd); }); upd();
    btn.addEventListener('click', function(){
      var v = cur(); if (!v || !v.available) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      var cd = document.querySelector('cart-drawer');
      fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      }).then(function(r){ return r.json(); }).then(function(res){
        if (res.status) { btn.textContent = res.description || 'Sold out'; return; }
        if (cd && cd.renderContents) { cd.classList.remove('is-empty'); cd.renderContents(res); } else { location.href = '/cart'; }
      }).catch(function(){}).finally(function(){ setTimeout(function(){ btn.disabled = false; upd(); }, 800); });
    });
    function toon(){ var r = mainBtn ? mainBtn.getBoundingClientRect() : null; bar.classList.toggle('is-visible', r ? r.bottom < 0 : window.scrollY > 700); }
    window.addEventListener('scroll', toon, { passive: true }); window.addEventListener('resize', toon); toon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sticky); else sticky();
})();

/* Collectie: producten vanzelf bijladen bij scrollen (+ knop "Load more" als terugval). Claude 16-10-2026 */
(function(){
  function init(){
    var grid = document.getElementById('product-grid'); var pag = document.querySelector('.pagination-wrapper');
    if (!grid || !pag || grid.tagName !== 'UL') return;
    var pijlen = pag.querySelectorAll('a.pagination__item-arrow'); var volgende = null;
    pijlen.forEach(function(a){ if (/next|volgende/i.test(a.getAttribute('aria-label') || '') ) volgende = a.href; });
    if (!volgende && pijlen.length) { var l = pijlen[pijlen.length - 1]; if (!l.closest('.pagination__item--prev') || pijlen.length === 1) volgende = l.href; }
    if (!volgende) { pag.style.display = 'none'; return; }
    var knop = document.createElement('button'); knop.type = 'button'; knop.className = 'button cl-more'; knop.textContent = 'Load more';
    var wrap = document.createElement('div'); wrap.className = 'cl-more-wrap'; wrap.appendChild(knop); pag.replaceWith(wrap);
    var bezig = false;
    function laad(){
      if (bezig || !volgende) return; bezig = true; knop.textContent = 'Loading…';
      fetch(volgende).then(function(r){ return r.text(); }).then(function(h){
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var nieuw = doc.getElementById('product-grid');
        if (nieuw) Array.prototype.forEach.call(nieuw.children, function(li){ grid.appendChild(li); });
        var np = doc.querySelector('.pagination-wrapper'); volgende = null;
        if (np) np.querySelectorAll('a.pagination__item-arrow').forEach(function(a){ if (/next|volgende/i.test(a.getAttribute('aria-label') || '')) volgende = new URL(a.getAttribute('href'), location.href).href; });
        if (!volgende) wrap.remove(); else knop.textContent = 'Load more';
        bezig = false;
      }).catch(function(){ bezig = false; knop.textContent = 'Load more'; });
    }
    knop.addEventListener('click', laad);
    if (window.IntersectionObserver) new IntersectionObserver(function(e){ if (e[0].isIntersecting) laad(); }, { rootMargin: '600px' }).observe(wrap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
